<template>
  <div class="header">
    <div class="logo"><!--/static/images/picLogo.png-->
      <div style="height: 40px;display: flex;align-items: flex-end">

        <el-dropdown trigger="click">
          <el-button style="font-size: 14px;padding: 5px 12px;" size="mini"
          >{{$t('lang')}}
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="toggle" v-if="!a">{{$t('zh')}}</el-dropdown-item>
            <el-dropdown-item @click.native="toggle" v-else="">{{$t('en')}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </div>
    </div>
    <div class="right">
      <div class="nav">
        <ul class="nav-list" v-if="USER_NAME == 3">
          <li class="nav5 navLi" @click="goto('/material')"><i class="icon iconfont icon-sucaiguanli"></i>{{$t('Material')}}
          </li>
          <li class="nav2 navLi" @click="goto('/program')"><i class="icon iconfont icon-jiemuxinzeng"></i>{{$t('Program')}}
          </li>
          <li class="nav3 navLi" @click="goto('/task')"><i class="icon iconfont icon-fuwurenwuguanli"></i>{{$t('Task')}}
          </li>
          <li class="nav1 navLi" @click="goto('/terminal')"><i class="icon iconfont icon-caizhi"></i>{{$t('Terminal')}}
          </li>
          <li class="nav4 navLi" @click="goto('/system')">
            <i class="icon iconfont icon-xitongpeizhi"></i>
            {{$t('Settings')}}
          </li>
          <li class="nav6 navLi" @click="goto('/management')" v-if="USER_NAME == 2 ||USER_NAME == 1 ||USER_NAME == 0"><i
              class="icon iconfont icon-kehuguanli_huaban"></i>
            {{$t('Manage')}}
          </li>
        </ul>
        <ul class="nav-list" v-else="">
          <li class="nav1 navLi" @click="goto('/terminal')"><i class="icon iconfont icon-caizhi"></i>{{$t('Terminal')}}
          </li>
          <li class="nav2 navLi" @click="goto('/program')"><i class="icon iconfont icon-jiemuxinzeng"></i>{{$t('Program')}}
          </li>
          <li class="nav3 navLi" @click="goto('/task')"><i class="icon iconfont icon-fuwurenwuguanli"></i>{{$t('Task')}}
          </li>
          <li class="nav5 navLi" @click="goto('/material')"><i class="icon iconfont icon-sucaiguanli"></i>
            {{$t('Material')}}
          </li>
          <li class="nav4 navLi" @click="goto('/system')">
            <i class="icon iconfont icon-xitongpeizhi"></i>
            {{$t('Settings')}}
          </li>
          <li class="nav6 navLi" @click="goto('/management')" v-if="((level < '4')&&(roleId == 1))"><i
              class="icon iconfont icon-kehuguanli_huaban"></i>
            {{$t('Manage')}}
          </li>
        </ul>

        <div style="display: none"></div>
      </div>

      <div class="user" v-if="level == '3'">
        <router-link to="/money">
            <span class="el-dropdown-link">
            <img src="/web/static/images/icon/money.png" style="width: 30px">
          </span>
        </router-link>
      </div>
      <div class="user">
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            <el-tooltip class="item" effect="dark" :content="username"
                        placement="top">
            <i class="icon iconfont icon-wode"></i>
            </el-tooltip>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="user()">{{$t('usercenter')}}</el-dropdown-item>
            <el-dropdown-item @click.native="mecancel()">{{$t('LogOff')}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div style="width: 33px;margin: 0 10px;height: 38px" @click="getApkAddr">
        <el-tooltip class="item" effect="dark" :content="$t('download')"
                    placement="top">
          <img src="/web/static/images/icon/load.png" alt="" style="width: 100%;height: 100%">
        </el-tooltip>
      </div>
      <!--用户中心弹窗-->
      <el-dialog
          :title="$t('usercenter')"
          :visible.sync="centerDialogVisible"
          :append-to-body="true"
          :show-close="false"
          :close-on-click-modal="false"
          width="30%">
        <div class="user-content">
          <el-row>
            <el-col :span="24" style="padding-bottom: 10px;">{{$t('account')}}: {{ userData.userName }}</el-col>
          </el-row>
        </div>
        <el-collapse accordion>
          <el-collapse-item>
            <template slot="title">
              {{$t('editpassword')}}
            </template>
            <el-form ref="fromdata" :model="fromdata" size="mini" :rules="rules" label-width="80px">
              <el-form-item :label="$t('oldPass')" prop="oldPassword">
                <el-input type="password" v-model="fromdata.oldPassword"
                          :placeholder="$t('placeholder.qsrjmm')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('newPass')" prop="password">
                <el-input type="password" v-model="fromdata.password" :placeholder="$t('login.newpass')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('system.confirmPassword')" prop="checkPass">
                <el-input type="password" v-model="fromdata.checkPass"></el-input>
              </el-form-item>
              <el-form-item style="text-align: right">
                <el-button type="primary" size="mini" @click="onSubmit('fromdata')">{{$t('immediately')}}</el-button>
              </el-form-item>
            </el-form>
          </el-collapse-item>
          <el-collapse-item v-if="level === '1'">
            <template slot="title">
              {{$t('edituser')}}
            </template>
            <el-form :model="renameuser" size="mini" label-width="80px">
              <el-form-item :label="$t('account') + ':'">
                <el-input v-model="renameuser.name"></el-input>
                <span style="font-size: 12px;color: #ff0000">ps:{{$t('uspix')}}</span>
              </el-form-item>
              <el-form-item :label="$t('phone') + '：'">
                <el-input v-model="renameuser.phone"></el-input>
              </el-form-item>
              <el-form-item style="text-align: right">
                <el-button type="primary" size="mini" @click="onSubmituser('renameuser')">{{$t('immediately')}}
                </el-button>
              </el-form-item>
            </el-form>
          </el-collapse-item>
        </el-collapse>
        <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">{{$t("btns.cancel")}}</el-button>
      </span>
      </el-dialog>
      <!--用户中心弹窗结束-->

    </div>
  </div>
</template>

<script>
import qs from "qs"

export default {
  name: "heade",
  inject: ['reload'],
  data() {
    //密码验证
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('login.password')))
      } else {
        if (this.fromdata.checkPass !== '') {
          this.$refs.fromdata.validateField('checkPass')
        }
        callback()
      }
    }
    //确认密码
    var validatePass2 = (rule, value, callback) => {

      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.fromdata.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    return {
      lang: "中文",
      roleId: localStorage.getItem('roleId'),
      url: window.location.href,
      isShow: false,
      centerDialogVisible: false,
      fromdata: {
        oldPassword: '',
        password: '',
        checkPass: ''
      },
      renameuser: {
        name: "",
        phone: ""
      },
      level: localStorage.getItem("level"),
      userData: {},
      username: "",
      rules: {//修改表单的验证
        oldPassword: [
          {required: true, message: this.$t('placeholder.qsrjmm'), trigger: 'blur'},
        ],
        password: [
          {required: true, validator: validatePass, trigger: 'blur'},
          {min: 5, max: 12, message: '密码必须在5-12个字符或数字', trigger: 'blur'}
        ],
        checkPass: [
          {required: true, validator: validatePass2, trigger: 'blur'}
        ]
      },
      a: true,
    }
  },
  created() {
    this.isShow = false
    this.username = localStorage.getItem("token")
  },
  mounted() {

    this.roleId = localStorage.getItem('roleId')
    this.level = localStorage.getItem("level")
    let locale = localStorage.getItem('language') || 'zh_CN'
    if (locale === 'zh_CN') {
      this.a = true
    } else {
      this.a = false
    }
    $(".nav-list > li").css({
      background: "#044184",
      color: "#ffffff",
      fontWeight: "100"
    })
    if (this.url.includes("terminal")) {
      $(".nav1").css({
        background: "#ffffff",
        color: "#044184",
        fontWeight: "700"
      })
    } else if (this.url.includes("material")) {
      $(".nav5").css({
        background: "#ffffff",
        color: "#044184",
        fontWeight: "700"
      })
    } else if (this.url.includes("program")) {
      $(".nav2").css({
        background: "#ffffff",
        color: "#044184",
        fontWeight: "700"
      })
    } else if (this.url.includes("system")) {
      $(".nav4").css({
        background: "#ffffff",
        color: "#044184",
        fontWeight: "700"
      })
    } else if (this.url.includes("task")) {
      $(".nav3").css({
        background: "#ffffff",
        color: "#044184",
        fontWeight: "700"
      })
    } else if (this.url.includes("management")) {
      $(".nav6").css({
        background: "#ffffff",
        color: "#044184",
        fontWeight: "700"
      })
    }
    this.globalClick(this.handleClickOut)

  },
  methods: {
    toggle() {
      /*let locale = localStorage.getItem('language') || 'zh_CN'
      let temp = locale === 'zh_CN' ? 'en_US' : 'zh_CN'
      this.$i18n.locale = temp//改变当前语言
      localStorage.language = temp
      this.lang = locale === 'zh_CN' ? 'English' : '中文'*/

      this.a = !this.a
      if (this.a) {
        this.$i18n.locale = "zh_CN"
      } else {
        this.$i18n.locale = "en_US"
      }
      localStorage.setItem('language', this.$i18n.locale)
      this.reload()
    },
    getApkAddr() {
      window.open('http://etv.esoncloud.com/#/myExplain', '_blank')
    },
    goto(url) {
      this.$router.push(url)
    },
    handleClickOut() {
      let cssName = $(event.target).parents(".nav1")
      if (cssName.length > 0) {
        let dd = cssName[0].className;
        if (dd === "nav1") {
          this.isShow = true;
        } else {
          this.isShow = false;
        }
      } else {
        // 处理未匹配到元素的情况
        // 可以根据实际需求进行操作
      }
    },
    mecancel() {//注销登录
      this.$confirm(this.$t('login.qdtc'), this.$t('tip.tip'), {
        confirmButtonText: this.$t('btns.confirm'),
        cancelButtonText: this.$t('btns.cancel'),
        type: 'warning'
      }).then(() => {
        console.log(159);
        localStorage.removeItem('token1')
        localStorage.removeItem('role')
        localStorage.removeItem('token')
        this.$router.push('/login')

        /* this.$ajax({
           url: '/etv/logout.json',
           method: 'post',
           header: {
             "token": $.cookie('token')
           }
         }).then(res => {
           let code = res.data.code
           console.log(code);
           if (code === 0) {


           }
         })*/
      }).catch(() => {

        this.$elementMessage(this.$t('tip.n'), "info")
      })

    },
    onSubmit(formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$ajax({
            url: '/etv/updatePassword.json',
            method: 'post',
            data: this.fromdata,
            cache: false,
            headers: {
              "token": localStorage.getItem("token1")
            },
            transformRequest: [function (data) {
              if (data instanceof FormData) {
                return data
              }
              data = qs.stringify(data)
              return data
            }]
          }).then(res => {

            let code = res.data.code
            let msg = res.data.msg
            if (code === 0) {

              _this.$elementMessage(msg, "success")
              _this.fromdata.oldPassword = ""
              _this.fromdata.password = ""
              localStorage.removeItem('token1')
              localStorage.removeItem('role')
              _this.$router.push('/login')

            } else if (code == 1) {
              _this.$elementMessage(msg, "error")
            } else {
              _this.$elementMessage(msg, "error")
            }
          })
        } else {

          return false
        }
      })

    },
    onSubmituser() {

      if (this.renameuser.phone === "" && this.renameuser.name === "") {
        this.$elementMessage(this.$t('tip.srpz'), "error")
        return
      }

      var reg = /[\u4e00-\u9fa5]/g
      if (reg.test(this.renameuser.name)) {
        this.$elementMessage(this.$t('tip.gecw'), "error")
        return
      }
      if ((/^1[34578]\d{9}$/.test(this.renameuser.phone)) && this.renameuser.phone == "") {
        this.$elementMessage(this.$t('login.phone'), "error")
        return
      }
      this.$ajax({
        url: '/etv/updateAccountName.json',
        method: 'post',
        data: qs.stringify({
          userName: this.renameuser.name,
          phone: this.renameuser.phone,

        }),
        cache: false,
        headers: {
          "token": localStorage.getItem("token1")
        },
      }).then(res => {
        let code = res.data.code
        let msg = res.data.msg
        if (res.data.code === 0) {
          this.fromdata.oldPassword = ""
          this.fromdata.password = ""
          localStorage.removeItem('token1')
          localStorage.removeItem('role')
          this.$router.push('/login')

        } else if (code == 1) {

          this.$elementMessage(msg, "error")
        } else {

          this.$elementMessage(msg, "error")
        }
      })
    },
    user() {
      this.centerDialogVisible = true
      this.$ajax({
        url: '/etv/selectPersonerInfoById.json',
        method: 'post',
        headers: {
          "token": localStorage.getItem("token1")
        }
      }).then(res => {
        let code = res.data.code
        let msg = res.data.msg
        if (code == 0) {
          this.userData = res.data.data
          this.renameuser.name = res.data.data.userName
          this.renameuser.phone = res.data.data.phone
        } else {

          this.$elementMessage(msg, "error")
        }
      })
    },
    yiru() {
      this.isShow = true
    },
    yichu() {
      this.isShow = false
    }
  },

}
</script>

<style scoped type="text/css" lang="scss">
.header {
  width: 100%;
  height: 65px;
  overflow: hidden;
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
  min-width: 1300px;

  .logo {
    float: left;
    display: flex;
    align-items: flex-end;
    height: 65px;
    /* width: 217px;*/
    cursor: pointer;
    box-sizing: border-box;

    img {
      /*width: 100%;*/
      height: 40px;
    }
  }

  .right {
    float: right;
    display: flex;
    align-items: flex-end;
    height: 100%;

    .nav {
      height: 46px;
      margin-right: 36px;

      .nav-list {
        list-style: none;
        display: flex;
        font-size: 18px;

        & > li {
          flex: 1;
          margin: 0 8px;
          display: flex;
          height: 46px;
          align-items: center;
          padding: 0 10px;
          box-sizing: border-box;
          border-radius: 5px 5px 0 0;
          background: #044184;
          color: #ffffff;
          letter-spacing: 1px;
          width: 140px;
          cursor: pointer;
          font-weight: 100;
          line-height: 46px;
          justify-content: center;

          i {
            margin-right: 3px;
            font-weight: 100;
            font-size: 18px;
          }

          .icon-guanli, .icon-jiemuxinzeng {
            font-size: 20px;
          }
        }

        & > li:hover {
          background: #ffffff !important;
          color: #044184 !important;
          font-weight: 700 !important;
        }

        & > li:hover .navigation {
          color: #555;
          font-size: 15px;
          font-weight: 100 !important;
        }

        .nav1 {
          .navigation {
            height: 124px;
            top: 65px;
            left: 236px;
            position: absolute;
            width: calc(100% - 236px);
            background: #ffffff;
            box-sizing: border-box;
            z-index: 999;

            .navigation-content {
              width: 1000px;
              height: 100%;
              margin: 0 auto;
              padding: 20px 0 15px 0;
              box-sizing: border-box;
              list-style: none;
              display: flex;

              li {
                flex: 1;
                padding: 0 50px;
                width: 67px;
                cursor: pointer;

                img {
                  display: block;
                  height: 56px;
                  margin: 0 auto;
                }

                div {
                  color: #555;
                  font-size: 15px;
                  text-align: center;
                }
              }
            }
          }
        }
      }
    }

    .user {
      height: 34px;
      width: 34px;
      border: 1px solid #fff;
      border-bottom: none;
      border-radius: 5px 5px 0 0;
      margin-right: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #FFFFFF;
      cursor: pointer;

      i {
        font-size: 28px;
      }

      .el-dropdown {
        color: #fff !important;
      }
    }
  }
}
</style>

<style>
.content .nav .nav_list a li:hover .list_zd[data-v-613e5ae0] {
  border: none;
}

.el-collapse-item__content {
  padding-bottom: 0;
}

.el-dropdown .active {
  background: none !important;
  color: #6d6d6d !important;
}

.el-dropdown-menu[data-v-613e5ae0] {
  background: #6d6d6d;
  border: 1px solid #c1c1c1;
}

/*  .el-dropdown-menu__item {
    color: #fff;
  }*/
.el-dropdown-menu__item:hover {
  background-color: #00A2FF !important;
  color: #ffffff !important;
}

.el-collapse-item__header {
  width: 80px;
}

.el-popper[x-placement^=bottom] .popper__arrow::after {
  border-bottom-color: #6d6d6d;
}

::-webkit-input-placeholder { /* WebKit browsers */
  color: #A9A9A9 !important;
}

:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  color: #A9A9A9 !important;
  opacity: 1;
}

::-moz-placeholder { /* Mozilla Firefox 19+ */
  color: #A9A9A9 !important;
  opacity: 1;
}

:-ms-input-placeholder { /* Internet Explorer 10+ */
  color: #A9A9A9 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue